import styles from './credit-dialog.module.scss';
import { useContext, useState } from 'react';

import { makeRequest } from '../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, MultiLineTextField, PrimaryButton, SnackBarContext, TextField, toCurrency } from '@frontend-workspace/react-shared-lib';

import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface CreditDialogProps {
  open: boolean,
  onClose: () => void,
  getData: () => void,
  contractId: string,
  balance: number
}

export function CreditDialog(props: CreditDialogProps) {
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [amount, setAmount] = useState<number>(0);
  const [message, setMessage] = useState<string>('');

  const handleAmountChange = (event: any) => setAmount(Number(event.target.value));
  const handleMessageChange = (event: any) => setMessage(event.target.value);
  const closeCreditDialog = () => props.onClose();

  const handleCreditTransaction = () => {
    const requestBody = {
      contractId: props.contractId,
      amount: amount,
      transactionText: message
    };

    makeRequest(`contracts/${props.contractId}/action/creditTransaction`, 'POST', requestBody).then(result => {
      setSnackbarMessage({ content: t('credit.creditingDone'), type: "success", });
      props.getData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('credit.couldNotPerformCrediting'), type: "error" }));
  };

  const amountAfterCredit = props.balance + amount;

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t('standard.credit')}
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column mb-3">
          <div className='mb-4'>{t('credit.amountAfterBalance')} {toCurrency(amountAfterCredit)}</div>
          <div className='mb-3'>
            <TextField
              fullWidth
              type="number"
              label={t('standard.amount')}
              name='amount'
              value={amount || ''}
              onChange={handleAmountChange}
              onFocus={event => { event.target.select() }}
            />
          </div>
          <div className='mb-3'>
            <MultiLineTextField
              fullWidth
              label={t('credit.message')}
              name='message'
              rows={5}
              value={message}
              onChange={handleMessageChange}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleCreditTransaction}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={closeCreditDialog}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreditDialog;